import {Injectable} from '@angular/core';
import {throwError} from 'rxjs';
import * as EmployeeModels from '@employee-models/index';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '@employee-configs/api.config';
import {catchError} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})

export class RejectReasonsService {

    private rejectReasonsData: EmployeeModels.DM.IRejectedPhotoReasonModel[] = [];

    constructor(private httpClient: HttpClient) {}

    fetchRejectReasons(): void {
        this.httpClient.get<EmployeeModels.DM.IRejectedPhotoReasonModel[]>(ApiConfig.Dictionary.getRejectedPhotoReasons)
            .pipe(
                catchError((error) => {
                    this.rejectReasons = [];
                    return throwError(error);
                })
            ).subscribe(data => this.rejectReasons = data);
    }

    get rejectReasons(): EmployeeModels.DM.IRejectedPhotoReasonModel[] {
        return this.rejectReasonsData;
    }

    set rejectReasons(value: EmployeeModels.DM.IRejectedPhotoReasonModel[]) {
        this.rejectReasonsData = value;
    }

}
